import { BaseAPI } from '../api-client';

export function uploadToS3(url: string, file: File): Promise<unknown> {
  return fetch(url, { method: 'PUT', body: file });
}

// TODO: Die darunterliegenden Funktionen bzw Klassen sind nur ein Hack, damit der File Upload direkt mit dem Server läuft.
// Sobald ihr den S3 Endpoint fertig habt, könnt ihr den Aufruf von "uploadDirectly" in "file-upload.tsx" mit "uploadToS3()" ersetzen.

class FileUploadApi extends BaseAPI {
  static from(api: BaseAPI) {
    return new FileUploadApi((api as any).configuration);
  }

  async uploadQuestionnaireArtefact(file: File) {
    await fetch(`${this.configuration.basePath}/api/questionnaire_artefacts`, {
      method: 'POST',
      credentials: 'include',
      body: file,
    });
  }
}

export function uploadDirectly(api: BaseAPI, file: File): Promise<unknown> {
  return FileUploadApi.from(api).uploadQuestionnaireArtefact(file);
}
